import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { v4 as uuidV4 } from 'uuid';

import translate from '../../libs/i18n';

import { ExamReportListStyle } from './ExamReportListStyle';
import ExamReportItem from '../ExamReportItem/ExamReportItem';
import EmptyListWarning from '../EmptyListWarning/EmptyListWarning';

const ExamReportList = ({ examList, onDeleteReportItem }) => {
  const language = useSelector((state) => state.settings.language);
  return (
    <ExamReportListStyle>
      <div className="exam-report-list-table-head">
        <div className="table-head-list table-head-item result-item">
          {translate('result', language)}
        </div>
        <div className="table-head-list information-list">
          <div className="table-head-item exame-type-item">
            {translate('modality', language)}
          </div>
          <div className="table-head-item series-description-item">
            {translate('serieDescriptionWithoutAsterisk', language)}
          </div>
          <div className="table-head-item patient-name-item">
            {translate('patientName', language)}
          </div>
          <div className="table-head-item patient-id-item">
            {translate('patientId', language)}
          </div>
          <div className="table-head-item registry-item">
            {translate('registry', language)}
          </div>
          <div className="table-head-item exam-date-item">
            {translate('examDate', language)}
          </div>
          <div className="table-head-item registration-date-item">
            {translate('examRegistration', language)}
          </div>
          <div className="table-head-item status-item">
            {translate('status', language)}
          </div>
        </div>
        <div className="table-head-list action-list">
          <div className="table-head-item actions-item">
            {translate('actions', language)}
          </div>
        </div>
      </div>
      {examList && examList.length ? (
        <ul className="exam-report-list-container">
          {examList.map((exam) => (
            <div
              key={exam && exam.id ? exam.id : uuidV4()}
              className="exam-report-item-wrapper"
            >
              <ExamReportItem exam={exam} onDeleteReport={onDeleteReportItem} />
            </div>
          ))}
        </ul>
      ) : (
        <EmptyListWarning
          messages={{
            firstMessage: translate('noResults', language),
            secondMessage: translate('noResultsDescription', language),
          }}
        />
      )}
    </ExamReportListStyle>
  );
};

ExamReportList.propTypes = {
  examList: PropTypes.arrayOf(PropTypes.object),
  onDeleteReportItem: PropTypes.func.isRequired,
};

ExamReportList.defaultProps = {
  examList: [],
};

export default ExamReportList;
